import classNames from 'classnames'

export function H1({ children, className, ...props }: React.HTMLProps<HTMLHeadingElement>) {
  return (
    <h1 {...props} className={classNames('text-basic heading-2xl', className)}>
      {children}
    </h1>
  )
}

export function H2({ children, className, ...props }: React.HTMLProps<HTMLHeadingElement>) {
  return (
    <h2 {...props} className={classNames('text-basic heading-xl', className)}>
      {children}
    </h2>
  )
}

export function H3({ children, className, ...props }: React.HTMLProps<HTMLHeadingElement>) {
  return (
    <h3 {...props} className={classNames('text-basic heading-lg', className)}>
      {children}
    </h3>
  )
}
